import React, { useEffect, useRef, useState } from "react";
import { TbFilter } from "react-icons/tb";

import { EVENT_TYPES } from "@helpers/data/eventTypes";

import styles from "./styles/eventTypeFilter.module.css";

function EventTypeFilter({ selectedTypes, onChange }) {
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);

  useEffect(() => {
    if (!open) {
      return undefined;
    }

    const handleClick = (event) => {
      if (rootRef.current && !rootRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, [open]);

  const toggleType = (value) => {
    if (selectedTypes.includes(value)) {
      if (selectedTypes.length === 1) {
        return;
      }
      onChange(selectedTypes.filter((type) => type !== value));
    } else {
      onChange([...selectedTypes, value]);
    }
  };

  return (
    <div className={styles.root} ref={rootRef}>
      <button
        type="button"
        className={`${styles.button} ${open ? styles.buttonActive : ""}`}
        aria-label="Фильтр по типу мероприятия"
        aria-expanded={open}
        onClick={() => setOpen((prev) => !prev)}
      >
        <TbFilter size={16} />
      </button>
      {open ? (
        <div className={styles.popup} role="dialog" aria-label="Типы мероприятий">
          <div className={styles.popupTitle}>Тип мероприятия</div>
          <ul className={styles.list}>
            {EVENT_TYPES.map((type) => (
              <li key={type.value}>
                <label className={styles.option}>
                  <input
                    type="checkbox"
                    checked={selectedTypes.includes(type.value)}
                    onChange={() => toggleType(type.value)}
                  />
                  <span>{type.label}</span>
                </label>
              </li>
            ))}
          </ul>
        </div>
      ) : null}
    </div>
  );
}

export default EventTypeFilter;
